import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckIsAdmin, ApiDeleteLocation, ApiGetLocation, ApiInsertLocation, ApiUpdateLocation } from "utils/constants/api";

export default function LocationForm(){
    let navigate = useNavigate()

    const{ fetch: insertLocation } = useFetch(ApiInsertLocation)
    const{ fetch: updateLocation } = useFetch(ApiUpdateLocation)
    const{ fetch: deleteLocation } = useFetch(ApiDeleteLocation)
    const{ fetch: getLocation } = useFetch(ApiGetLocation)
    const{ fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramLocationId = queryString.get("locationId")
    
    const [locationId, setLocationId] = useState(EmptyString)
    const [locationName, setLocationName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [province, setProvince] = useState(EmptyString)
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [file, setFile] = useState(EmptyString)
    
    const [kostId, setKostId] = useState(EmptyString)
    const [kostCode, setKostCode] = useState(EmptyString)
    const [kostName, setKostName] = useState(EmptyString)
    const [postalCode, setPostalCode] = useState(EmptyString)
    const [picName, setPicName] = useState(EmptyString)
    const [picPhone, setPicPhone] = useState(EmptyString)

    
    const [errorKostId, setErrorKostId] = useState(false)
    const [errorKostCode, setErrorKostCode] = useState(false)
    const [errorKostName, setErrorKostName] = useState(false)
    const [errorAddress, setErrorAddress] = useState(false)
    const [errorCity, setErrorCity] = useState(false)
    const [errorProvince, setErrorProvince] = useState(false)
    const [errorPostalCode, setErrorPostalCode] = useState(false)
    const [errorPicName, setErrorPicName] = useState(false)
    const [errorPicPhone, setErrorPicPhone] = useState(false)


    const [kostIdDisabled, setKostIdDisabled] = useState(true)
    const [kostCodeDisabled, setKostCodeDisabled] = useState(false)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        if(formType === FormTypeEdit){
            setLoading(true)
            fCheckIsAdmin()
            fGetLocation(paramLocationId).then(() => {
                setLoading(false)
            })
        }
    }, [])

    // Function Api Call
    async function fInsertLocation(){
        await insertLocation({
            data: {
                locationName: locationName,
                address: address,
                city: city,
                province: province,
                phone: phone,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateLocation(){ 
        await updateLocation({
            data: {
                locationId: paramLocationId,
                locationName: locationName,
                address: address,
                city: city,
                province: province,
                phone: phone,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetLocation(paramLocationId){
        await getLocation({
            data: {
                locationId: paramLocationId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                setLocationId(data.locationId)
                setLocationName(data.locationName)
                setAddress(data.address)
                setCity(data.city)
                setProvince(data.province)
                setPhone(data.phone)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }    
    async function fDeleteLocation(paramLocationId){
        await deleteLocation({
            data: {
                locationId: paramLocationId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/location")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                id: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Button
    function fSaveBtnClick(){
        //if(fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })

                setLoading(true)

                if(formType === FormTypeAdd){
                    fInsertLocation().then(() => {
                        setLoading(false)
                    })
                }else{
                    fUpdateLocation().then(() => {
                        setLoading(false)
                    })
                }
            }}})
        //}
    }
    function fDeleteBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading(true)

            fDeleteLocation(paramLocationId).then(() => {
                setLoading(false)
            })
        }}})
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (kostCode === null || kostCode === EmptyString){
            errorCount++
            setErrorKostCode(true)
        }else{
            setErrorKostCode(false)
        }
        if (kostName === null || kostName === EmptyString){
            errorCount++
            setErrorKostName(true)
        }else{
            setErrorKostName(false)
        }
        if (address === null || address === EmptyString){
            errorCount++
            setErrorAddress(true)
        }else{
            setErrorAddress(false)
        }
        if (city === null || city === EmptyString){
            errorCount++
            setErrorCity(true)
        }else{
            setErrorCity(false)
        }
        if (province === null || province === EmptyString){
            errorCount++
            setErrorProvince(true)
        }else{
            setErrorProvince(false)
        }
        if (postalCode === null || postalCode === EmptyString){
            errorCount++
            setErrorPostalCode(true)
        }else{
            setErrorPostalCode(false)
        }
        if (picName === null || picName === EmptyString){
            errorCount++
            setErrorPicName(true)
        }else{
            setErrorPicName(false)
        }
        if (picPhone === null || picPhone === EmptyString){
            errorCount++
            setErrorPicPhone(true)
        }else{
            setErrorPicPhone(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function handleChange(e) {
        setFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    

    return(
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-2xl">Location Detail</span>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Location Id */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Location Id</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={locationId} onChange={(e) => { setLocationId(e.target.value) }} disabled={true} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorKostId ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Location Id is required!</span>
                    </div>
                </div>

                 {/* Location Name */}
                 <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Location Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={locationName} onChange={(e) => { setLocationName(e.target.value) }} maxLength={30} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorKostName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Kost Name is required!</span>
                    </div>
                </div>

                {/* Address */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-start">
                        <div className="w-48 pt-2">
                            <span>Address</span>
                        </div>
                        <div className="px-4 pt-2 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <textarea className="input" value={address} onChange={(e) => { setAddress(e.target.value) }} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorAddress ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Address is required!</span>
                    </div>
                </div>

                {/* City */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>City</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={city} onChange={(e) => { setCity(e.target.value) }} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCity ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">City is required!</span>
                    </div>
                </div>

                {/* Province */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Province</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={province} onChange={(e) => { setProvince(e.target.value) }} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorProvince ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Province is required!</span>
                    </div>
                </div>

                {/* Phone */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Phone</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ phone } onChange={(e) => { setPhone(e.target.value) }} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex flex-wrap items-center ${ errorPicPhone ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">PIC Phone is required!</span>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex justify-end gap-2">
                <SaveButton onClick={() => { fSaveBtnClick() }} visible={true} />                
                <DeleteButton onClick={() => { fDeleteBtnClick() }} visible={formType === FormTypeEdit ? true : false} />
                <BackButton onClick={() => { navigate("/location") }} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>


    )
}